// Qaytarma və endirim qaydaları (ekranda). Gizlətmə və ilkin yoxlama yalnız rahatlıqdır — əsl yoxlama API-dədir.
import type { SaleCardLine } from '@kassa/shared';

/** Endirim limiti (faiz): kassir bundan çox endirimi menecer PİN-i ilə edir (API ilə eyni). */
export const DISCOUNT_LIMIT_PCT = 5;

/** Qaytarıla bilən qalan miqdar (3 onluqla). */
export function remainingQty(line: Pick<SaleCardLine, 'qty' | 'returnedQty'>): number {
  return Math.max(0, Math.round((line.qty - line.returnedQty) * 1000) / 1000);
}

/** Daxil edilən miqdar qalanla məhdudlanır (mənfi və qalandan çox olmur). */
export function clampReturnQty(value: number, remaining: number): number {
  if (!Number.isFinite(value) || value <= 0) return 0;
  return Math.min(value, remaining);
}

/** Sətir üzrə qaytarılan məbləğ (satış sətrinin məbləğinin ödənilən hissəsi). */
export function lineRefund(line: Pick<SaleCardLine, 'amount' | 'qty'>, qty: number): number {
  if (line.qty <= 0) return 0;
  return Math.round(((line.amount * qty) / line.qty) * 100) / 100;
}

/** Ödəniş bölgüsü: satışın nağd/kart/nisyə payına görə qaytarma məbləği. */
export function refundSplit(total: number, parts: { cash: number; card: number; credit: number }, amount: number) {
  if (total <= 0) return { cash: 0, card: 0, credit: 0 };
  const card = Math.round(((amount * parts.card) / total) * 100) / 100;
  const credit = Math.round(((amount * parts.credit) / total) * 100) / 100;
  return { cash: Math.round((amount - card - credit) * 100) / 100, card, credit };
}

/** Endirimin faizi (sətir brutto məbləğinə görə). */
export function discountPercent(gross: number, discount: number): number {
  if (gross <= 0) return 0;
  return Math.round((discount / gross) * 10000) / 100;
}

/** Server PİN tələb edən xəta kodlarından biridir: PİN pəncərəsi açılır. */
export function needsPin(code: string | undefined): boolean {
  return code === 'return_pin' || code === 'discount_limit' || code === 'credit_limit' || code === 'pin_invalid';
}
